import Chat from './chat.vue'

import $chats from 'stores/chats'
import $global from 'stores/global'

const __default__ = {
  data() {
    return {
      chat: undefined
    }
  },
  async mounted() {
    if (this.$route.query.id) {
      this.chat = $chats.getChat(this.$route.query.id)
      //chat id in url may be invalid, or already removed
      if (!this.chat) {
        $global.goToChats()
        return
      }
      await this.chat.load()
    }
  },
  beforeUnmount() {
    if (this.chat) {
      this.chat.abortTasksListener()
      this.chat = undefined
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'chats',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get $chats() { return $chats }, get $global() { return $global }, Chat }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})